// useAnalyticsEventTracker.js
const useAnalyticsEventTracker = (category = 'Event Category') => {
  const eventTracker = (action = 'action', label = 'label', value = '') => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', action, {
        'event_category': category,
        'event_label': label,
        'value': value,
      });
    }
  };
  return eventTracker;
};

export default useAnalyticsEventTracker;
